import React, { memo } from 'react';
import css from './ShippingDetailsForm.module.css';
import { FREE, SHIPPING } from '../../../util/constants';
import { Field } from 'react-final-form';

const shippingOptions = [
  { key: SHIPPING, label: 'Buyer pays shipping' },
  { key: FREE, label: 'Free shipping on all orders' },
];

/**
 * Component that renders a pair of radio buttons for selecting whether
 * shipping is free or the buyer pays.
 *
 * @param {Object} form - The form API object provided by final-form.
 * @param {Object} intl - The intl object provided by react-intl.
 * @param {Object} values - The current values of the form.
 *
 * @returns {ReactElement} A div containing two radio buttons and their labels.
 */
const ShippingOptions = ({ form, intl, values }) => {
  const { shippingType } = values || {};

  return (
    <div className={css.tutulistOptionBlock}>
      <div className={css.shippingOptions}>
        {shippingOptions.map(({ key, label }) => (
          <Field name="shippingType" key={key} type="radio" value={key}>
            {({ input }) => (
              <div className={css.option}>
                <input {...input} id={key} type="radio" checked={shippingType === key} />
                <label htmlFor={key} role="button">
                  {key === FREE ? (
                    <>{intl.formatMessage({ id: 'ShippingDetailsForm.free' })}</>
                  ) : (
                    label
                  )}
                </label>
              </div>
            )}
          </Field>
        ))}
      </div>
    </div>
  );
};

export default memo(ShippingOptions);
